import React, { useState, createContext, useContext } from 'react';
type Page = 'home' | 'terms' | 'privacy';
interface NavigationContextType {
  currentPage: Page;
  navigate: (page: Page) => void;
}
const NavigationContext = createContext<NavigationContextType | undefined>(undefined);
export function NavigationProvider({
  children
}: {
  children: ReactNode;
}) {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const navigate = (page: Page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };
  return <NavigationContext.Provider value={{
    currentPage,
    navigate
  }} data-id="element-231">
      {children}
    </NavigationContext.Provider>;
}
export function useNavigation() {
  const context = useContext(NavigationContext);
  if (context === undefined) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
}